import ApiNotFoundError from 'utils/api/errors/ApiNotFoundError';
import ApiPermissionDeniedError from 'utils/api/errors/ApiPermissionDeniedError';
import ApiError from 'utils/api/errors/ApiError';
import ApiInternalServerError from 'utils/api/errors/ApiInternalServerError';
import ApiNetworkAuthRequiredError from 'utils/api/errors/ApiNetworkAuthRequiredError';
import ApiBadGatewayError from 'utils/api/errors/ApiBadGatewayError';
import ApiBadRequestError from 'utils/api/errors/ApiBadRequestError';
import ApiUnauthorizedError from 'utils/api/errors/ApiUnauthorizedError';
import ApiNetworkError from 'utils/api/errors/ApiNetworkError';
import ApiMultiDeviceError from 'utils/api/errors/ApiMultiDeviceError';


function getErrorCode (error) {
  return error.status || error.errorCode || error.response && error.response.status;
}


function handleApiError (error) {
  // if not http error throw it
  if (!(error.isAxiosError || error.status || error.errorCode || error.response && error.response.status)) {
    throw error;
  }

  // handle network error this way, because it has no error code and this handler is for axios and backbone fetch
  if (error.message === 'Network Error') {
    throw new ApiNetworkError(error);
  }

  const errorCode = getErrorCode(error);

  switch (errorCode) {
  case 400:
    throw new ApiBadRequestError(error);
  case 401:
    throw new ApiUnauthorizedError(error);
  case 403:
    throw new ApiPermissionDeniedError(error);
  case 404:
    throw new ApiNotFoundError(error);
  case 420:
    throw new ApiMultiDeviceError(error);
  case 500:
    throw new ApiInternalServerError(error);
  case 502:
    throw new ApiBadGatewayError(error);
  case 511:
    throw new ApiNetworkAuthRequiredError(error);
  default:
    throw new ApiError(error, errorCode);
  }
}


export default handleApiError;
export {getErrorCode};
